import {
  BaseButton,
  Props as BaseButtonProps,
} from '../../LegacyButton/BaseButton';

type Props = Omit<
  BaseButtonProps,
  | 'children'
  | 'color'
  | 'iconBefore'
  | 'isFullWidth'
  | 'hasShadow'
  | 'isPill'
  | 'isSquare'
  | 'size'
> & {
  /** Optional prop, set to true if this button is in the selected state. */
  selected?: boolean;
  /** The button's contents. We only want to allow number values here. */
  value: number;
  /** The button's size, options are `small` and `medium`. Default is `small`. */
  size?: Exclude<BaseButtonProps['size'], 'large' | 'compact'>;
};

/**
 * ## ⚠️ This component is deprecated in favor of Button β.
 *
 * `NumberButton`s are `Button`s that render numbers within them, such as page buttons for paginated collections. Used in `Paginator`.
 *
 * @deprecated Use Button β instead.
 */
export function NumberButton({
  selected,
  value,
  size = 'small',
  ...buttonProps
}: Props) {
  return (
    <BaseButton
      color="number"
      isSquare={true}
      isSelected={selected}
      size={size}
      {...buttonProps}
    >
      {value}
    </BaseButton>
  );
}
